<template>
  <section class="fc-introduce-instructor" :class="slug">
    <h4 class="fc-introduce-instructor__title">강사 소개</h4>
    <h6 class="fc-introduce-instructor__sub-title">{{ subTitle }}</h6>
    <ul class="fc-introduce-instructor__columns">
      <li class="fc-introduce-instructor__column">
        <figure class="fc-introduce-instructor__icon">
          <img :src="slug === 'data_online_fin' ? InstructorImg01 : InstructorImg02" alt="" />
        </figure>
        <div class="fc-introduce-instructor__contents">
          <span class="fc-introduce-instructor__title">{{ name }}</span>
          <p class="fc-introduce-instructor__content" v-html="career" />
        </div>
      </li>
      <li class="fc-introduce-instructor__column">
        <span class="fc-introduce-instructor__title">강사님 한마디</span>
        <p class="fc-introduce-instructor__content">{{ mention }}</p>
      </li>
      <a :href="link" target="_blank" class="fc-introduce-instructor__button btn" v-if="link">강사님 인터뷰 ></a>
    </ul>
  </section>
</template>

<script>
import InstructorImg01 from '../../../../img/ab-test/instructor_01.png';
import InstructorImg02 from '../../../../img/ab-test/instructor_02.png';

export default {
  name: 'introduce-instructor',
  props: ['slug', 'subTitle', 'name', 'career', 'mention', 'link'],
  data() {
    return {
      InstructorImg01,
      InstructorImg02,
    };
  },
};
</script>
